/** Откуда пришёл новый игрок (v0.34) — уходит на сервер один раз, вместе с
 *  онбордингом. Бесплатное продвижение живёт на ссылках, и без этого не
 *  понять, какой плакат, пост или игрок привёл людей.
 *
 *  - Telegram: startapp=r<id> — личная ссылка игрока; s_<код> — плакат/пост
 *    (сайт передаёт код из /r/<код>); g<игра>_i<игрок> — приглашение в игру;
 *    g<игра> — карточка игры в чате; web — кнопка на сайте.
 *  - Браузер и приложение: код, который сайт запомнил из /?src=<код>
 *    (тот же origin — localStorage), иначе платформа (web, app-ios…). */

import { isNative, nativePlatform } from './platform'
import { tg } from './telegram'

const KEY = 'por4_src'
const CODE = /^[a-z0-9][a-z0-9-]{0,38}$/

export interface Attribution {
  ref_source: string | null
  referrer_id: number | null
}

function stored(): string | null {
  try {
    const v = window.localStorage.getItem(KEY)
    return v && CODE.test(v) ? v : null
  } catch {
    return null
  }
}

/** Вызывается при запуске: ?src= в адресе (после /r/<код>) запоминаем. */
export function rememberSource(): void {
  const src = new URLSearchParams(window.location.search).get('src')?.toLowerCase()
  if (!src || !CODE.test(src)) return
  try {
    window.localStorage.setItem(KEY, src)
  } catch {
    /* приватный режим — переживём без источника */
  }
}

function fromCode(code: string): Attribution {
  const personal = code.match(/^u(\d+)$/)
  return personal ? { ref_source: 'ref', referrer_id: Number(personal[1]) } : { ref_source: code, referrer_id: null }
}

export function initialAttribution(): Attribution {
  const start = tg?.initDataUnsafe?.start_param
  if (start) {
    let m = start.match(/^r(\d+)$/)
    if (m) return { ref_source: 'ref', referrer_id: Number(m[1]) }
    m = start.match(/^s_([a-z0-9-]{1,39})$/)
    if (m) return fromCode(m[1])
    m = start.match(/^g\d+_i(\d+)$/)
    if (m) return { ref_source: 'invite', referrer_id: Number(m[1]) }
    if (/^g\d+$/.test(start)) return { ref_source: 'game', referrer_id: null }
    if (/^b\d+$/.test(start)) return { ref_source: 'booking', referrer_id: null }
    if (start === 'web') return fromCode(stored() ?? 'site')
  }
  const code = stored()
  if (code) return fromCode(code)
  if (tg?.initData) return { ref_source: 'telegram', referrer_id: null }
  return { ref_source: isNative ? `app-${nativePlatform}` : 'web', referrer_id: null }
}
